export const switchAppTheme = (isDarkMode: boolean) => {
  if (isDarkMode) {
    document.getElementsByTagName("html")[0].classList.add("mode-dark", "dark");
  } else {
    document
      .getElementsByTagName("html")[0]
      .classList.remove("mode-dark", "dark");
  }
};
